<section class="text-center">
    <header>
        <img src="/assets/media/msis/404.svg" alt="404 page" />
        <h2>Sorry, we can't find the page you are looking for.</h2>
        <a  href="/dashboard" class="font-weight-bold h3 mt-3">Go Back Home</a>
    </header>
    <!-- <p class="fw1 i tc mt4 mt5-l f4 f3-l">Are you looking for one of these?</p> -->
</section>
